import { type SearchQuestionQSetUsageRecordsQuery } from '@report/graphql';
import { styled, TableCell, TableRow } from '@shared/components';

import { useQuestionUsageByQSetReportSearchParams } from '../../hooks';

export interface QuestionUsageByQSetReportTableBodyProps {
  rows: SearchQuestionQSetUsageRecordsQuery['reportSearchQuestionQSetUsageRecords']['records'];
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

export default function QuestionUsageByQSetReportTableBody(
  props: Readonly<QuestionUsageByQSetReportTableBodyProps>,
) {
  const [{ pageSize, page }] = useQuestionUsageByQSetReportSearchParams();
  const { rows } = props;
  return (
    <>
      {rows.map((row, rowIndex) => {
        return (
          <TableRow key={row.questionRefCode} sx={{ border: 'none' }}>
            <StyledTableCell align='center' sx={{ minWidth: '64px' }}>
              {rowIndex + 1 + page * pageSize}
            </StyledTableCell>
            <StyledTableCell align='left' sx={{ minWidth: '200px' }}>
              {row.questionRefCode}
            </StyledTableCell>
            <StyledTableCell align='left' sx={{ minWidth: '100px' }}>
              {row.calculated ? 'คำนวน' : 'ไม่คำนวน'}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.pInitial.toFixed(2) ?? '-'}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.pUsed.toFixed(2) ?? '-'}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.bIndexInitial === null ? '-' : row.bIndexInitial.toFixed(2)}
            </StyledTableCell>
            {row.qSetUsages.map((qSetUsage, qSetIndex) => (
              <StyledTableCell
                sx={{
                  backgroundColor: (theme) =>
                    qSetUsage.isUsed ? theme.palette.success.light : undefined,
                  minWidth: '80px',
                }}
                align='center'
                key={`qSetUsage-${rowIndex}-${qSetIndex}`}
              >
                {qSetUsage.isUsed ? 'Y' : '-'}
              </StyledTableCell>
            ))}
          </TableRow>
        );
      })}
    </>
  );
}
